// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Avatar = require("../common/Components/Avatar.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let AvatarSrcUrl = require("../../utils/AvatarSrcUrl.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let AccountMemberUtils = require("./AccountMemberUtils.bs.js");
let SubusersPageAccountsListItem = require("./SubusersPageAccountsListItem.bs.js");

function SubuserMemberListItem(props) {
  return JsxRuntime.jsx(SubusersPageAccountsListItem.make, {
    member: props.member,
    account: props.account,
    render: (name, member, actions, confirmation, editor) => {
      let match = member.agent.profilePhoto;
      return JsxRuntime.jsxs("div", {
        children: [
          confirmation,
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Avatar.make, {
              name: name,
              src: match !== undefined ? match.url : AvatarSrcUrl.place_holder,
              size: 1
            })
          }),
          editor !== undefined ? editor : JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                          children: name,
                          className: "font-semibold"
                        }),
                        JsxRuntime.jsx("div", {
                          children: name === member.agent.displayName ? null : JsxRuntime.jsx("div", {
                              children: member.agent.displayName
                            }),
                          className: "text-gray-500"
                        })
                      ]
                    }),
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                              children: Stdlib_Option.getOr(Stdlib_Option.map(member.agent.emailAddress, e => Scalars.EmailAddress.toString(e)), null),
                              className: ""
                            }),
                            JsxRuntime.jsx("div", {
                              children: Stdlib_Option.getOr(Stdlib_Option.map(Stdlib_Option.flatMap(member.role, r => SubusersPageAccountsListItem.MemberFragment.accountMemberRole_decode(r)), AccountMemberUtils.roleToString), null),
                              className: "text-gray-500"
                            })
                          ],
                          className: ""
                        }),
                        className: "col-span-3 flex justify-between"
                      })
                    })
                  ],
                  className: "flex flex-row space-x-4"
                }),
                JsxRuntime.jsx("div", {
                  children: actions
                })
              ],
              className: "flex flex-row space-x-4 justify-between w-full"
            })
        ],
        className: "flex flex-row space-x-4 my-4 items-start"
      });
    },
    currentUserRole: props.currentUserRole
  });
}

let make = SubuserMemberListItem;

exports.make = make;
/* Avatar Not a pure module */
